import React, { useState, useEffect } from "react";
import Avatar from "../Avatar/Avatar";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import verticalDots from "../../assets/verticalDots.svg";
import {
  currentOrganizationOwnerSelector,
  currentOrganizationSelector,
  currentProjectsStructureSelector,
  organizationUsersSelector,
  userSelector,
} from "../../store/selectors";
import toast from "react-hot-toast";
import subfolderIcon from "../../assets/subfolder.svg";
import versionIcon from "../../assets/versionIcon.svg";
import arrowDown from "../../assets/arrowDown.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserProjectRoles,
  inviteUserToOrganization,
} from "../../store/usersSlice";
import uncheckedIcon from "../../assets/unchecked.svg";
import checkedIcon from "../../assets/checked.svg";
import {
  addUserToProject,
  deepSet,
  fetchProjectById,
  fetchProjectByIdForAccess,
  fetchProjectsForAccess,
  removeUserFromProject,
} from "../../store/projectsSlice";
import "./VideoPage.css";
import { OrbitProgress } from "react-loading-indicators";
import CloseButton from "../CloseButton/CloseButton";

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 102000,
  },
  modal: {
    width: "454px",
    height: "600px",
    backgroundColor: "#1f242e",
    borderRadius: "16px",
    padding: "32px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  pill: {
    background: "#333B4B",
    color: "#c1c4cb",
    borderRadius: "24px",
    padding: "8px 24px",
    fontSize: "16px",
    fontWeight: 500,
    margin: "16px 0 24px 0",
    display: "inline-block",
  },
  inviteRow: {
    display: "flex",
    alignItems: "stretch",
    width: "100%",
    marginBottom: "20px",
  },
  inviteInputWrap: {
    display: "flex",
    flex: 1,
    border: "1px solid #333b4b",
    borderRadius: "80px",
    overflow: "hidden",
  },
  inviteInput: {
    flex: 1,
    height: "auto",
    padding: "12px 16px",
    borderTopLeftRadius: "80px",
    borderBottomLeftRadius: "80px",
    backgroundColor: "transparent",
    border: "none",
    color: "#F1F7FF",
    fontSize: "14px",
    fontWeight: 500,
  },
  inviteDivider: {
    width: "1px",
    backgroundColor: "#333b4b",
    margin: "12px 0",
  },
  inviteSelect: {
    padding: "12px 16px",
    backgroundColor: "transparent",
    border: "none",
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23717b8e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    textAlign: "right",
    paddingRight: "36px",
    WebkitTapHighlightColor: "transparent",
    WebkitTouchCallout: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    userSelect: "none",
    outline: "none",
    textAlign: "right",
  },
  inviteBtn: {
    marginLeft: "8px",
    padding: "12px 24px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  inviteBtnDisabled: {
    marginLeft: "8px",
    padding: "12px 24px",
    backgroundColor: "#4a4f5c",
    borderRadius: "80px",
    border: "none",
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "default",
    whiteSpace: "nowrap",
  },
  memberList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "300px",
    overflowY: "auto",
    overflowX: "hidden",
    width: "100%",
    marginTop: "8px",
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE and Edge */,
    "&::-webkit-scrollbar": {
      /* Chrome, Safari and Opera */ display: "none",
    },
  },
  memberRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px",
    borderRadius: "8px",
    boxSizing: "border-box",
    width: "100%",
    background: "#232733",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  email: {
    flex: 1,
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  select: {
    padding: "8px 0 8px 16px",
    backgroundColor: "transparent",
    border: "none",
    color: "#717b8e",
    marginBottom: 3,
    fontSize: "14px",
    fontWeight: 500,
  },
  selectOwner: {
    color: "#c1c4cb",
    cursor: "default",
    backgroundImage: "none",
  },
  submitButton: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    position: "absolute",
    bottom: 30,
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    ":hover": {
      opacity: 0.9,
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
};

const AccessPopup = ({ isOpen, onClose, editedUser, onSave = () => {} }) => {
  // State for context menu (anchor and target user)
  const dispatch = useDispatch();
  const [menuAnchor, setMenuAnchor] = useState(null); // anchor = {userId, left, top}
  const [isLoading, setIsLoading] = useState(false);
  const [menuUser, setMenuUser] = useState(null);
  const [initiallyLoaded, setInitiallyLoaded] = useState(false);
  const user = useSelector(userSelector);
  const currentProjectsStructure = useSelector(
    currentProjectsStructureSelector
  );
  const [currentProject, setCurrentProject] = useState(null);
  const [userRoles, setUserRoles] = useState({});
  const [updatedUserRoles, setUpdatedUserRoles] = useState({});
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [currentOrgStructure, setCurrentOrgStructure] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    calculateProjectsStructure();
  }, [isOpen]);

  // Handle Escape key to close popup
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  // Handle click outside menu
  useEffect(() => {
    if (!menuAnchor) return;
    const handleClickOutside = (e) => {
      // Close if click is outside
      if (
        menuAnchor &&
        e.target &&
        !e.target.closest(".user-context-menu") &&
        !e.target.closest(".user-list-dots-btn")
      ) {
        e.preventDefault();
        e.stopPropagation();
        setMenuAnchor(null);
        setMenuUser(null);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, [menuAnchor]);
  if (!isOpen) return null;

  const calculateProjectsStructure = async () => {
    const userProjectRolesRes = await dispatch(
      fetchUserProjectRoles({
        organizationId: currentOrganization.id,
        userId: editedUser && editedUser.userId,
      })
    );
    if (userProjectRolesRes.error) return;
    const newUserRoles = {};
    for (let i = 0; i < userProjectRolesRes.payload.length; i++) {
      newUserRoles[userProjectRolesRes.payload[i].projectId] =
        userProjectRolesRes.payload[i];
    }
    setUserRoles(newUserRoles);
    setUpdatedUserRoles(newUserRoles);

    const projectsStructure = {};
    dispatch(
      fetchProjectsForAccess({ organizationId: currentOrganization.id })
    ).then(async (res) => {
      if (!res.error) {
        const rootProjectsArray = res.payload;
        for (let i = 0; i < rootProjectsArray.length; i++) {
          projectsStructure[rootProjectsArray[i].id] = {
            id: rootProjectsArray[i].id,
            title: rootProjectsArray[i].title,
            isFolder: true,
            isVersion: false,
            children: {},
          };
        }
      }
      populateStructure(projectsStructure);
    });
  };

  const getProjectChildren = async (projectId) => {
    const result = {};
    const projectRes = await dispatch(fetchProjectByIdForAccess({ projectId }));
    if (projectRes.error) return result;
    const fetchedProject = projectRes.payload;
    for (let i = 0; i < fetchedProject.versions.length; i++) {
      result[fetchedProject.versions[i].id] = {
        id: fetchedProject.versions[i].id,
        title: fetchedProject.versions[i].version,
        isFolder: false,
        isVersion: true,
        parentId: +projectId,
      };
    }
    for (let i = 0; i < fetchedProject.subprojects.length; i++) {
      const fetchedSubprojectBranch = await getProjectChildren(
        fetchedProject.subprojects[i].id
      );
      result[fetchedProject.subprojects[i].id] = {
        id: fetchedProject.subprojects[i].id,
        title: fetchedProject.subprojects[i].title,
        isFolder: true,
        isVersion: false,
        parentId: +projectId,
        children: {
          ...fetchedSubprojectBranch,
        },
      };
    }
    return result;
  };

  const populateStructure = async (rootProjectsStructure) => {
    const newProjectsStructure = {
      ...rootProjectsStructure,
    };
    for (let i = 0; i < Object.keys(rootProjectsStructure).length; i++) {
      const projectId = Object.keys(rootProjectsStructure)[i];
      const branch = await getProjectChildren(projectId);
      newProjectsStructure[projectId].children = {
        ...branch,
        ...newProjectsStructure[projectId].children,
      };
    }
    setCurrentOrgStructure(newProjectsStructure);
    setInitiallyLoaded(true);
  };

  const switchProjectUnfolded = (id, isUnfolded, path) => {
    let newProjectStructure = { ...currentOrgStructure };
    const pathString = path
      .reduce((acc, curr) => {
        return acc + `.${curr.id}.children`;
      }, "")
      .slice(1)
      .slice(0, -9);
    deepSet(newProjectStructure, pathString + ".isUnfolded", isUnfolded);
    setCurrentOrgStructure(newProjectStructure);
  };

  const onClickDot = (explorerItem, hasAccess, parentHasAccess) => {
    if (parentHasAccess) return;
    let newUpdatedRoles = { ...updatedUserRoles };
    const roleEntityId = explorerItem.isVersion
      ? explorerItem.parentId
      : explorerItem.id;
    console.log(roleEntityId);
    if (!hasAccess) {
      const existingRoleEntry = newUpdatedRoles[roleEntityId];
      if (!existingRoleEntry) {
        const newRoleEntry = {
          id: null,
          projectId: roleEntityId,
          allowedContentVersionIds: explorerItem.isVersion
            ? [explorerItem.id]
            : [],
          role: "ADMIN",
          status: "ACTIVE",
          organizationdId: currentOrganization.id,
        };
        newUpdatedRoles = {
          ...newUpdatedRoles,
          [roleEntityId]: newRoleEntry,
        };
      } else {
        let changedRoleEntry = {
          ...existingRoleEntry,
          markedForDelete: false,
        };
        if (explorerItem.isVersion) {
          changedRoleEntry.allowedContentVersionIds = [
            ...changedRoleEntry.allowedContentVersionIds,
            explorerItem.id,
          ];
          newUpdatedRoles = {
            ...newUpdatedRoles,
            [roleEntityId]: changedRoleEntry,
          };
        } else {
          changedRoleEntry = {
            ...changedRoleEntry,
            allowedContentVersionIds: [],
          };
          newUpdatedRoles = {
            ...newUpdatedRoles,
            [roleEntityId]: changedRoleEntry,
          };
        }
      }
    } else {
      const existingRoleEntry = newUpdatedRoles[roleEntityId];
      let changedRoleEntry = { ...existingRoleEntry };
      if (explorerItem.isVersion) {
        changedRoleEntry.allowedContentVersionIds =
          changedRoleEntry.allowedContentVersionIds.filter(
            (entry) => entry !== explorerItem.id
          );
        if (changedRoleEntry.allowedContentVersionIds.length === 0) {
          changedRoleEntry.markedForDelete = true;
        }
        newUpdatedRoles = {
          ...newUpdatedRoles,
          [roleEntityId]: changedRoleEntry,
        };
      } else {
        changedRoleEntry = {
          ...changedRoleEntry,
          allowedContentVersionIds: [],
          markedForDelete: true,
        };
        newUpdatedRoles = {
          ...newUpdatedRoles,
          [roleEntityId]: changedRoleEntry,
        };
      }
    }
    console.log(newUpdatedRoles);
    setUpdatedUserRoles(newUpdatedRoles);
    // console.log(explorerItem, editedUser);
  };

  const renderExplorerItem = (
    explorerItem,
    activePadding = 12,
    isLastChild = false,
    parentHasAccess = false
  ) => {
    const isOrganization = !!explorerItem.isOrg;
    const isVersion = !explorerItem.isFolder;
    const isSubfolder = !explorerItem.isRoot && !isVersion;

    const isCurrentFolder =
      (currentProject && explorerItem.id === currentProject.id) ||
      (currentProject &&
        currentProject.versions.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1) ||
      (currentProject &&
        currentProject.subprojects.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1);

    const isCurrentProject =
      currentProject && explorerItem.id === currentProject.id;

    const isCurrentPath =
      currentProject &&
      currentProject.path.findIndex(
        (pathEntry) => pathEntry.id === explorerItem.id
      ) !== -1;

    const isCurrentRoot = explorerItem.isRoot && isCurrentPath;
    const isHovered = false;

    const hasAccess =
      (!isVersion &&
        !!updatedUserRoles[explorerItem.id] &&
        updatedUserRoles[explorerItem.id].allowedContentVersionIds.length ===
          0 &&
        !updatedUserRoles[explorerItem.id].markedForDelete) ||
      (isVersion &&
        !!updatedUserRoles[explorerItem.parentId] &&
        updatedUserRoles[
          explorerItem.parentId
        ].allowedContentVersionIds.includes(explorerItem.id));

    return (
      <>
        <div
          onClick={(e) => onClickDot(explorerItem, hasAccess, parentHasAccess)}
          style={{
            position: "absolute",
            left: 0,
            // top: 10,
            // transform: "translateY(-50%)",
            cursor: "pointer",
            padding: "4px",
          }}
        >
          <img
            src={hasAccess || parentHasAccess ? checkedIcon : uncheckedIcon}
            alt="options"
            style={{
              width: 24,
              height: 24,
              opacity: !hasAccess && parentHasAccess ? 0.5 : 1,
            }}
          />
        </div>
        <div
          key={explorerItem.id}
          className="projectExplorer-project-item"
          onClick={() => {
            setCurrentProject({
              id: explorerItem.id,
              path: [],
              versions: [],
              subprojects: [],
            });
          }}
          style={{
            cursor: "pointer",
            paddingLeft: activePadding,
            position: "relative",
            marginLeft: 64,
            marginBottom: 6,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 6,
              height: 6,
              position: "absolute",
              left: -8 + activePadding,
            }}
          >
            {(!isVersion || isOrganization) && (
              <img
                src={arrowDown}
                alt="arrow"
                style={{
                  width: 6,
                  height: 6,
                  // transform:
                  //   (!isCurrentPath && !isOrganization) ||
                  //   explorerItem.isUnfolded
                  //     ? "rotate(-90deg)"
                  //     : "rotate(0deg)",
                }}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: 5,
            }}
          >
            {!isOrganization && (
              <img
                src={
                  isSubfolder
                    ? subfolderIcon
                    : isVersion
                    ? versionIcon
                    : subfolderIcon
                }
                alt="arrow"
                style={{
                  width: 28,
                  height: 28,
                }}
              />
            )}
          </div>
          <div
            style={{
              maxWidth: isHovered ? "85%" : "85%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              className="projectExplorer-project-item-title"
              style={{
                color: isOrganization
                  ? "rgb(166, 134, 237)"
                  : isVersion
                  ? "C1C7D4"
                  : isCurrentFolder
                  ? "#F1F7FF"
                  : "#C1C7D4",

                transition: "margin-right 0.1s ease",
                maxWidth: "100%",
                textOverflow: "ellipsis",
              }}
            >
              {explorerItem.title || explorerItem.version}
            </span>
            {isOrganization && (
              <span style={{ color: "grey", fontSize: 10, marginLeft: 5 }}>
                workspace
              </span>
            )}
          </div>
        </div>
        {((!explorerItem.isRoot || isCurrentRoot) &&
          explorerItem.children &&
          Object.keys(explorerItem.children).length !== 0 &&
          Object.values(explorerItem.children).map((child, index) =>
            renderExplorerItem(
              child,
              activePadding + 26,
              index === Object.values(explorerItem.children).length - 1,
              hasAccess || parentHasAccess
            )
          )) ||
          null}
      </>
    );
  };

  const onPressSave = async () => {
    setIsLoading(true);
    const userEmail = editedUser.email;
    const userId = editedUser.userId;
    console.log(
      "OLD ROLES: ",
      userRoles,
      ", NEW ROLES: ",
      updatedUserRoles,
      ", PROJECTS STRUCTURE: ",
      currentOrgStructure
    );
    const newUserRolesIds = Object.keys(updatedUserRoles);

    for (let i = 0; i < newUserRolesIds.length; i++) {
      const roleEntityId = newUserRolesIds[i];
      if (
        !userRoles[roleEntityId] &&
        updatedUserRoles[roleEntityId].markedForDelete
      ) {
        console.log(
          roleEntityId,
          " - Пропускаем, роли до этого не было и она не нужна"
        );
        // Пропускаем, роли до этого не было и она не нужна
      }
      if (
        !userRoles[roleEntityId] &&
        !updatedUserRoles[roleEntityId].markedForDelete
      ) {
        if (
          updatedUserRoles[roleEntityId].allowedContentVersionIds.length === 0
        ) {
          await dispatch(
            addUserToProject({
              projectId: updatedUserRoles[roleEntityId].projectId,
              userData: {
                email: userEmail,
                role: "ADMIN",
              },
            })
          );
        } else {
          console.log(
            "NEW VERSIONS ADDED",
            updatedUserRoles[roleEntityId].allowedContentVersionIds
          );
          for (
            let k = 0;
            k < updatedUserRoles[roleEntityId].allowedContentVersionIds.length;
            k++
          ) {
            let versionId =
              updatedUserRoles[roleEntityId].allowedContentVersionIds[k];
            console.log(versionId);
            await dispatch(
              addUserToProject({
                projectId: updatedUserRoles[roleEntityId].projectId,
                userData: {
                  email: userEmail,
                  role: "ADMIN",
                  versionId,
                },
              })
            );
          }
        }
        console.log(
          roleEntityId,
          " - Роли до этого не было, создаем новую, один раз - если проект, либо по разу на каждую, если версии"
        );
        // Роли до этого не было, создаем новую, один раз - если проект, либо по разу на каждую, если версии
      }

      if (
        !!userRoles[roleEntityId] &&
        !!updatedUserRoles[roleEntityId].markedForDelete
      ) {
        await dispatch(
          removeUserFromProject({
            projectId: updatedUserRoles[roleEntityId].projectId,
            userId,
          })
        );
        console.log(
          roleEntityId,
          "Роль до этого была, и она помечена на удаление - удаляем роль"
        );
        // Роль до этого была, и она помечена на удаление - удаляем роль
      }

      if (
        !!userRoles[roleEntityId] &&
        !updatedUserRoles[roleEntityId].markedForDelete
      ) {
        await dispatch(
          removeUserFromProject({
            projectId: updatedUserRoles[roleEntityId].projectId,
            userId,
          })
        ); //удаляем старую роль
        if (
          updatedUserRoles[roleEntityId].allowedContentVersionIds.length === 0
        ) {
          await dispatch(
            addUserToProject({
              projectId: updatedUserRoles[roleEntityId].projectId,
              userData: {
                email: userEmail,
                role: "ADMIN",
              },
            })
          );
        } else {
          for (
            let k = 0;
            k < updatedUserRoles[roleEntityId].allowedContentVersionIds.length;
            k++
          ) {
            let versionId =
              updatedUserRoles[roleEntityId].allowedContentVersionIds[k];
            await dispatch(
              addUserToProject({
                projectId: updatedUserRoles[roleEntityId].projectId,
                userData: {
                  email: userEmail,
                  role: "ADMIN",
                  versionId,
                },
              })
            );
          }
        }
        console.log(
          roleEntityId,
          "Роль до этого была, и все еще есть, что то поменялось, удаляем старую роль и назначаем новую (или новые, если это версии)"
        );
        // Роль до этого была, и все еще есть, что то поменялось, удаляем старую роль и назначаем новую (или новые, если это версии)
      }
    }
    setIsLoading(false);
    onSave();
    onClose();
    toast.success("Изменения сохранены!");
  };

  const page = (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <CloseButton onClose={onClose} transform="scale(2)" />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignSelf: "flex-start",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              color: "#c1c4cb",
              fontSize: 24,
              fontWeight: 500,
              marginBottom: 0,
            }}
          >
            Дать
          </span>
          <Avatar name={editedUser?.email || ""} user={editedUser} size={26} />
          <span
            style={{
              color: "#c1c4cb",
              fontSize: 24,
              fontWeight: 500,
              marginBottom: 0,
            }}
          >
            доступ к папкам
          </span>
        </div>
        <div
          className="access-modal-scroll"
          style={{
            width: "100%",
            marginTop: 20,
            marginBottom: 50,
            paddingBottom: 20,
            overflow: "scroll",
            position: "relative",
          }}
        >
          {initiallyLoaded ? (
            Object.values(currentOrgStructure).map((explorerItem) =>
              renderExplorerItem(explorerItem)
            )
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OrbitProgress
                style={{ fontSize: 14, alignSelf: "center" }}
                color={"#333b4b"}
              />
            </div>
          )}
        </div>
        <button
          disabled={isLoading}
          onClick={() => {
            onPressSave();
          }}
          style={{ ...modalStyles.submitButton, opacity: isLoading ? 0.5 : 1 }}
        >
          {isLoading ? "Сохраняем..." : "Сохранить"}
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(page, document.body);
};

export default AccessPopup;
